module.exports = __webpack_public_path__ + "assets/img/generate_output_tree.5fa4b4b5.png";